export default __webpack_public_path__ + "static/media/PahnkeMovieNight-screenshot-desktop.7882973d.png";